import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranslationLoadingService {
  isLoading = signal<boolean>(false);
}
